import * as React from 'react';
import { WindowWrapper } from 'login-utils/globalWrappers';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import ReCAPTCHA from 'react-google-recaptcha';
import * as inputUtils from '../inputUtils';

// istanbul ignore next: (UI-5482)
const Captcha = ({ meta, input }: InputProps) => {
  return (
    <div className="Captcha">
      <div className="Captcha-inputWrapper" id={inputUtils.getIdFromName(input.name)}>
        <ReCAPTCHA sitekey={WindowWrapper.RecaptchaKey} onChange={response => input.onChange(response)} />
      </div>
      {meta.touched && meta.error && (
        <div className="Captcha-errorWrapper">
          <ErrorMessage errorText={meta.error} />
        </div>
      )}
    </div>
  );
};

export const CaptchaConfig = {
  component: Captcha,
};

export default Captcha;
